export const EDITOR_LEFT_MARGIN = 120;
export const EDITOR_RIGHT_MARGIN = 342;
export const EDITOR_RIGHT_MARGIN_SMALL = 50;
export const EDITOR_BOTTOM_BAR_BOTTOM_OFFSET = 12;

const SCROLL_VELOCITY_WINDOW_MS = 80;
const MAX_RENDER_AHEAD_BUFFER = 200;
const MIN_RENDER_AHEAD_BUFFER = 20;

interface ScrollSample {
  time: number;
  top: number;
  left: number;
}

export class ScrollVelocityTracker {
  private samples: ScrollSample[] = [];

  recordSample(top: number, left: number): void {
    const now = performance.now();
    this.samples.push({time: now, top, left});
    this.samples = this.samples.filter((s) => now - s.time <= SCROLL_VELOCITY_WINDOW_MS);
  }

  computeRenderAheadBuffer(scale: number): number {
    const scaleAdjustedMin = Math.min(50, Math.max(MIN_RENDER_AHEAD_BUFFER, Math.round(MIN_RENDER_AHEAD_BUFFER / scale)));

    if (this.samples.length < 2) {
      return MAX_RENDER_AHEAD_BUFFER;
    }

    const oldest = this.samples[0];
    const newest = this.samples[this.samples.length - 1];
    const windowDt = newest.time - oldest.time;

    if (windowDt <= 0) {
      return MAX_RENDER_AHEAD_BUFFER;
    }

    const distance = Math.max(Math.abs(newest.top - oldest.top), Math.abs(newest.left - oldest.left));
    const velocity = distance / windowDt; // px/ms
    return Math.min(MAX_RENDER_AHEAD_BUFFER, Math.max(scaleAdjustedMin, Math.round(velocity * 40)));
  }
}
